import { ActionTree } from "vuex";
import * as Sentry from "@sentry/vue";
import { StateInterface } from "src/store";
import { KbStateInterface } from "./state";
import API from "src/services/api/api";
import EventBus from "src/services/event-bus";

const actions: ActionTree<KbStateInterface, StateInterface> = {
  getEntities({ commit }, { filter_name = "", parent_id = null }) {
    return new Promise((resolve) => {
      API.sqlr
        .get_bl_1_entities({
          filter_name,
          parent_id,
          limit: undefined,
          offset: undefined,
        })
        .then((data) => {
          const container: any[] = [];
          data.forEach((e: any) => {
            container.push({ label: e.id, lazy: e.num_ch > 0 });
            commit("updateEntities", e);
          });
          resolve(container);
        });
    }).catch((error) => {
      Sentry.captureException(error);
    });
  },

  getEntitieData({ commit }, { ent_id }) {
    const as1 = API.sqlr
      .get_bl_1_synonyms({ ent_id, limit: undefined, offset: undefined })
      .then((data) => commit("updateSynonymsData", data));
    const as2 = API.sqlr
      .get_bl_1_descriptions({ ent_id, limit: undefined, offset: undefined })
      .then((data) => commit("updateDescriptionsData", data));
    return Promise.all([as1, as2]);
  },

  changeName({ commit }, { ent }) {
    API.sqlr
      .update_bl_1_entities({ id: ent.id, name: ent.name })
      .then(() => commit("updateEntitieName", ent))
      .catch((error) => {
        EventBus.$emit("outErrorMessage", {
          message: "Произошла ошибка при изменении имени",
          e: error,
        });
        Sentry.captureException(error);
      });
  },

  changeSynonym({ commit }, { syn }) {
    API.sqlr
      .update_bl_1_synonyms({ id: syn.id, synonym: syn.synonym })
      .then(() => commit("saveSynonym", syn))
      .catch((error) => {
        EventBus.$emit("outErrorMessage", {
          message: "Произошла ошибка при изменении синонима",
          e: error,
        });
        Sentry.captureException(error);
      });
  },

  changeDescription({ commit }, { desc }) {
    API.sqlr
      .update_bl_1_descriptions({
        id: desc.id,
        description: desc.description,
      })
      .then(() => commit("saveDescription", desc))
      .catch((error) => {
        EventBus.$emit("outErrorMessage", {
          message: "Произошла ошибка при изменении описания",
          e: error,
        });
        Sentry.captureException(error);
      });
  },

  createEntity({ commit }, { parent_id, name }) {
    // console.log("create ent with", "parent_id=", parent_id, "name=", name);
    API.sqlr.add_bl_1_entity({ parent_id, name }).then((id) => {
      commit("createEntity", { id, parent_id, name });
      //   showSucces("Дочерняя сущность создана");
      // временный костыль
      window.location.reload();
    });
  },

  deleteEntity({ dispatch, commit }, ent_id) {
    // TODO: state update when deleted
    API.sqlr.delete_bl_1_entity({ ent_id: ent_id }).then(() => {
      // commit("clearEntities");
      // временный костыль
      window.location.reload();
    });
  },

  createSynonym({ commit }, { parent_id, synonym = "" }) {
    API.sqlr
      .add_bl_1_synonyms({ parent_id: parent_id, synonym: synonym })
      .then((id) => {
        if (id != null) {
          commit("createSynonym", {
            parent_id: parent_id,
            syn_id: id,
            synonym: synonym,
          });
          //   showSucces("Синоним создан");
        } else {
          EventBus.$emit("outErrorMessage", {
            message: "Введите текст синонима в добавленной строке",
          });
        }
      });
    // console.log(parent_id, synonym);
  },

  createDescription(
    { commit },
    { parent_id, class_id = null, description = "" }
  ) {
    API.sqlr
      .add_bl_1_descriptions({
        parent_id: parent_id,
        class_id: class_id,
        description: description,
      })
      .then((id) => {
        commit("createDescription", {
          parent_id: parent_id,
          class_id: class_id,
          desc_id: id,
          description: description,
        });
        // showSucces("Описание создано");
      });
    // console.log(parent_id, description);
  },

  deleteSynonym({ commit }, { syn_id }) {
    API.sqlr.delete_bl_1_synonyms({ id: syn_id }).then((id) => {
      commit("deleteSynonym", id);
      //   showSucces("Синоним удалён");
    });
  },

  deleteDescription({ commit }, { desc_id }) {
    API.sqlr.delete_bl_1_descriptions({ id: desc_id }).then((id) => {
      commit("deleteDescription", id);
      //   showSucces("Описание удалено");
    });
  },
};

export default actions;
